import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit {
	@Input() title: string;
	@Input() tooltip: string;
	@Input() subtitle: string;
	@Input() error: string;
	@Input() name: string;
	@Input() attributes: attributes;
	@Input() ngClass: string;
	constructor() {}

	async ngOnInit() {}

	isString(val): boolean {
		return typeof val === 'string' || val instanceof String;
	}
}
